// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"9b283ddb","203":"08b0c79b","229":"d2100190","231":"567aeb11","526":"3e4d93af","533":"2a22b980","550":"fedf632a"}[chunkId] + ".chunk.css";
};